import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utilRules from '@/libs/rules';
import bankList from '@/const/bank';

var imgUrl = require('@/assets/image/img-time.png');

var formData = {
  payerAccountName: '',
  payerAccount: '',
  payerBankName: '',
  depositAmount: '',
  depositImage: ''
};

var rulelist = _toConsumableArray(Object.keys(formData).map(function (v) {
  return v;
}));

export default {
  meta: {
    title: '等待工作人员确认',
    auth: true,
    authorityValue: "store-store-bond-info"
  },
  name: 'bondWait',
  data: function data() {
    return {
      imgUrl: imgUrl,
      layer: {
        show: false,
        title: '修改保证金转账信息',
        showButton: true
      },
      options: bankList,
      checked: false,
      dataObj: {},
      formData: formData,
      rules: utilRules(rulelist)
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var query;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = _this.$route.query;

              _this.dataBind(query);

              _this.getQiNiu();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data, key, ind;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.depositDetails(item);

              case 2:
                data = _context2.sent;
                _this2.dataObj = data;

                for (key in data) {
                  for (ind in _this2.formData) {
                    if (key == ind) _this2.formData[ind] = data[key];
                  }
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.formData, key, this.VUE_APP_IMG_BASE + response.key);
      this.$refs['formData'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    confirm: function confirm() {
      var _this3 = this;

      this.$refs.formData.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          var query;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!valid) {
                    _context3.next = 7;
                    break;
                  }

                  query = _this3.$route.query;
                  _context3.next = 4;
                  return _this3.$api.deposit(_objectSpread(_objectSpread({}, _this3.formData), query));

                case 4:
                  _this3.dataBind(query);

                  YL.message('修改成功');
                  _this3.layer.show = false;

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};